module.exports = __webpack_public_path__ + "img/logo_desknetsneo.6a0f121b.png";